import { Button } from 'lego-on-react';
import React, { FC } from 'react';

import block from 'propmods';

import './Pagination.scss';
const b = block('Pagination');

interface Props {
    currentPage: number;
    pageCount: number;
    onSelect: (page: number) => void;
}

const Pagination: FC<Props> = (props) => {
    const { pageCount, currentPage, onSelect } = props;
    const dots = '...';

    const delta = 5;
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const result: Array<string | number> = Array.from({ length: pageCount }, (v, k) => k + 1).filter(
        (i) => i && i >= left && i < right,
    );

    if (result.length > 1) {
        if (Number(result[0]) > 1) {
            if (Number(result[0]) > 2) {
                result.unshift(dots);
            }
            result.unshift(1);
        }

        if (Number(result[result.length - 1]) < pageCount) {
            if (result[result.length - 1] !== pageCount - 1) {
                result.push(dots);
            }
            result.push(pageCount);
        }
    }

    return (
        <div {...b()}>
            {result.map((x, i) =>
                typeof x === 'string' ? (
                    <div {...b('dots')} key={i}>
                        {x}
                    </div>
                ) : (
                    <div key={i} {...b('btn')}>
                        <Button theme="clear" size="m" onClick={() => onSelect(x)} disabled={x === currentPage}>
                            <span {...b('btn-text', { current: x === currentPage })}>{x}</span>
                        </Button>
                    </div>
                ),
            )}
        </div>
    );
};

export default Pagination;
